import {
  titleUI,
  radioUI,
  radioSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import {
  applicationInfoFields,
  DRIVER_OR_PASSENGER,
  FORM_21_4502,
} from '../definitions/constants';

const { VEHICLE_USE: VU } = FORM_21_4502;

/** @type {PageSchema} */
export default {
  uiSchema: {
    'ui:options': { preserveHiddenData: true, forceDivWrapper: true },
    ...titleUI(VU.TITLE, VU.DESCRIPTION),
    'ui:order': [applicationInfoFields.parentObject, 'view:passengerInfoAlert'],
    [applicationInfoFields.parentObject]: {
      [applicationInfoFields.driverOrPassenger]: radioUI({
        title: VU.QUESTION,
        labels: DRIVER_OR_PASSENGER,
        required: () => true,
        hint: VU.HINT,
        errorMessages: {
          required: VU.ERROR,
        },
      }),
    },
    'view:passengerInfoAlert': {
      'ui:field': 'ViewField',
      'ui:options': {
        hideIf: formData =>
          formData?.applicationInfo?.driverOrPassenger !== 'passenger',
      },
    },
  },
  schema: {
    type: 'object',
    properties: {
      [applicationInfoFields.parentObject]: {
        type: 'object',
        properties: {
          [applicationInfoFields.driverOrPassenger]: radioSchema(
            Object.keys(DRIVER_OR_PASSENGER),
          ),
        },
        required: [applicationInfoFields.driverOrPassenger],
      },
      'view:passengerInfoAlert': { type: 'object', properties: {} },
    },
  },
};
